import React from 'react';
import {Breadcrumb} from "react-bootstrap";
import {IndexLinkContainer, LinkContainer} from "react-router-bootstrap";
import * as qs from 'query-string';
import * as Acl from "./acl";
import * as Grid from './grid';
import * as Enums from "./enums";
import * as Date from "./date";
import * as Files from "./files";

export {Acl};
export {Date};
export {Enums};
export {Files};
export {Grid};
export {qs};

const stubs = {
	'main': 'Biatlon online',
	'page': null,
	'tab': null
};

export const setPageTitle = (text, stub = 'page') => {
	stubs[stub] = text;
	document.title = stubs['main']
		+ (stubs['page'] ? ' | ' + stubs['page'] : '')
		+ (stubs['tab'] ? ' | ' + stubs['tab'] : '')
};

export const breadcrumbs = (crumbs) => {
	const items = [];

	let pageTitle = stubs['main'];
	if (crumbs) {
		for (let i = 0; i < crumbs.length; i++) {
			const title = crumbs[i].literal ? crumbs[i].title : crumbs[i].title;
			if (i + 1 >= crumbs.length) {
				items.push(<Breadcrumb.Item key={i} active>
					<h2>{title}</h2>
				</Breadcrumb.Item>);
				pageTitle += " | " + title;
			} else {
				items.push(<LinkContainer key={i} to={crumbs[i].url}>
					<Breadcrumb.Item>
						{title}
					</Breadcrumb.Item>
				</LinkContainer>)
			}
		}
	}
	document.title = pageTitle;

	return <Breadcrumb className={"hidden-xxs"}>
		<IndexLinkContainer to="/">
			<Breadcrumb.Item>
				Domů
			</Breadcrumb.Item>
		</IndexLinkContainer>
		{items}
	</Breadcrumb>;
};



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/utils/index.js